import { render, staticRenderFns } from "./BusinessPlanDeleteConfirmationModal.vue?vue&type=template&id=0cb81912"
import script from "./BusinessPlanDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessPlanDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports